import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	EditVideoContext,
	IEditVideoContext,
} from 'modules/Entertainment/Videos/EditVideo/editVideoState/editVideoContext';
import React, { useContext, useMemo } from 'react';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './EditForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const EditForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const { setFileId, deletePhoto, videoID, iconFileId, iconFilePath } =
		useContext<IEditVideoContext>(EditVideoContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath: iconFilePath,
			preSignedUrl: null,
			entityID: videoID,
		}),
		[iconFilePath, videoID],
	);

	return (
		<div className={containerClasses} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={iconFileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				maxHeight={1024}
				maxWidth={1024}
				verticalAspectRatio={1}
				horizontalAspectRatio={1}
				withValidation={true}
				noImageIconId="videoDefaultAvatar"
			/>
			<InputFields />
		</div>
	);
};

export default EditForm;
